<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-row>
        <el-col :span="8">
          <el-form-item>
            <el-button type="primary" size="medium" @click="importOrder()">+创建订单</el-button>
            <el-button :type="allSelectedIds.length ? 'primary':'info'" size="medium" @click="delectUser()">批量删除</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table ref="checktableData" :data="list" v-loading="listLoading" @selection-change="handleSelectionChange" :reserve-selection="true" height="60vh">
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column label="回收商品" width="300">
        <template slot-scope="scope">
          <div class="goodsStyle">
            <el-image style="width: 80px; height: 80px;margin-right:20px" fit="cover" :src="scope.row.goodsNorms"></el-image>
            <span>{{scope.row.goodsType}}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="订单编号">
        <template slot-scope="scope">{{scope.row.orderNum}}</template>
      </el-table-column> -->
      <el-table-column label="订单状态">
        <template slot-scope="scope">{{scope.row.orderState}}</template>
      </el-table-column>
      <!-- <el-table-column label="下单时间">
        <template slot-scope="scope">{{scope.row.createdDate | formatDateTimeDefault}}</template>
      </el-table-column> -->
      <el-table-column label="联系电话">
        <template slot-scope="scope">{{scope.row.yddh}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goCheck(scope.row.id)">查看</el-button>
          <el-button type="text" @click="delectUser(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes,prev, pager, next,jumper" :current-page.sync="search.pageNum" :page-size="search.pageSize" :page-sizes="[10,20]" :total="total">
      </el-pagination>
    </div>

    <el-row type="flex" justify="end" class="orderEdit">
      <el-col :span="5">
        <el-button @click="cancel()">
          取消
        </el-button>
        <el-button @click="confirm()" type="primary" :loading="confimload">
          确认
        </el-button>
      </el-col>
    </el-row>

    <el-dialog title="订单创建" :visible.sync="dialogVisible" width="400px" top="32vh" center>
      <div>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">下载excel模版</el-col>
          <el-col :span="8">
            <el-button type="primary" @click="download()">
              <div class="btnclass">
                <img src="../../assets/download.png" alt="">
                <span>excel模版下载</span>
              </div>
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" class="row-bg">
          <el-col :span="8" class="font-blod">导入excel</el-col>
          <el-col :span="8">
            <file-upload ref="Defaultfileupload" @addUpload="importUpdateDefaultByExcel" @removeUpload="removueFile" :title="'导入普通订单'" :limit="1" v-if="Default" />
            <div style="margin-bottom: 10px;"></div>
            <file-upload ref="Branchesfileupload" @addUpload="importUpdateBranchesByExcel" @removeUpload="removueFile" :title="'导入网点订单'" :limit="1" v-if="Branches" />
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="tableBtn">
        <div @click="dialogVisible = false">取 消</div>
        <div @click="submitExcel()">确认导入</div>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import FileUpload from '@/components/Upload/fileUpload';
export default {
  components: { FileUpload },
  data() {
    return {
      list: [],
      search: {
        pageSize: 10,
        pageNum: 1,
      },
      isEdit: false,
      listLoading: false,
      dialogVisible: false,
      confimload: false,
      userTypeList: [
        {
          label: "用户",
          value: "1",
        },
        {
          label: "回收员",
          value: "2",
        },
        {
          label: "网点",
          value: "3",
        },
      ],
      userStateList: [
        {
          label: "冻结",
          value: "0",
        },
        {
          label: "可用",
          value: "1",
        },
      ],
      // 选中过的页码
      selectedPageNums: [],
      // 选中也所有的数据
      selectedAllData: [],
      // 是否全选中
      allChecked: false,
      allSelectedIds: [],
      unSelectedIds: [],// 所有未选中的id
      oldarr: [],
      arr: [],
      total: 0,
      defaultLoading: false,
      branchesLoading: false,
      Default: true,
      Branches: true,
      defaultUpLoadData: {},
      branchesUpLoadData: {},
      type: 1,//1 普通订单 0 网点订单
      key: '',
    }
  },
  filters: {
    userStateType(value) {
      if (value) {
        return '可用'
      } else {
        return '冻结'
      }
    },
    userType(value) {
      if (value === 1) {
        return '用户'
      } else if (value === 2) {
        return '回收员'
      } else {
        return '网点'
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        setTimeout(() => {
          if (!this.global.handleEmptyData(this.defaultUpLoadData)) {
            this.$refs.Defaultfileupload.$refs.upload.clearFiles()
          } else {
            this.$refs.Branchesfileupload.$refs.upload.clearFiles()
          }
          this.defaultUpLoadData = {}
          this.branchesUpLoadData = {}
          this.Branches = true
          this.Default = true
        }, 100)

      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.query.key) {
        vm.key = from.query.key
        vm.type = from.query.type
        vm.getList()
      }
    });
  },
  created() {
    // this.getList()
    console.log(this.$route, "route")
  },
  methods: {
    //网点订单列表查询
    getBranchesList() {
      let { pageSize, pageNum, } = this.search || ''
      let params = {
        pageSize: pageSize,
        pageNum: pageNum,
        key: this.key
      }
      this.HttpService.post('/autoapp-default-server-recovery/api/tblRecycleOrder/getWdOrderImportList', params).then(res => {
        if (res.data.length === 0) {
          // this.$dialog({
          //   title: '温馨提示',
          //   content: '未查询到结果!',
          //   footBtn: false,
          //   width: '20%',
          //   dialogType: 'sighicon',
          // })
          this.list = res.data
        } else {

          res.data.forEach(async element => {
            let { goodsType } = element
            let params = {
              objectName: goodsType === "空调" ? 'order/goods_air_conditioner.png' : goodsType === "电视" ? 'order/goods_television.png' : goodsType === "电脑" ? 'order/goods_computer.png' : goodsType === "冰箱" ? 'order/goods_refrigerator.png' : 'order/goods_washing_machine.png'
            }
            const img = await this.axios({
              url: process.env.BASE_API + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrlStr?objectName=${params.objectName}`,
              method: 'GET',
              headers: { // 设置请求头
                Authorization: this.$store.getters.token
              }
            }).then(res => {
              return res.data.data
            })
            element.goodsNorms = img
          })
          this.total = res.total
          this.arr = res.data
          this.list = this.arr.slice(0, this.search.pageSize)
        }

      })
    },
    //普通订单列表查询
    getDefaultList() {
      let { pageSize, pageNum, } = this.search || ''
      let params = {
        pageSize: pageSize,
        pageNum: pageNum,
        key: this.key
      }
      this.HttpService.post('/autoapp-default-server-recovery/api/tblRecycleOrder/getOrderImportList', params).then(res => {
        if (res.data.length === 0) {
          // this.$dialog({
          //   title: '温馨提示',
          //   content: '未查询到结果!',
          //   footBtn: false,
          //   width: '20%',
          //   dialogType: 'sighicon',
          // })
          this.list = res.data
        } else {

          res.data.forEach(async element => {
            let { goodsType } = element
            let params = {
              objectName: goodsType === "空调" ? 'order/goods_air_conditioner.png' : goodsType === "电视" ? 'order/goods_television.png' : goodsType === "电脑" ? 'order/goods_computer.png' : goodsType === "冰箱" ? 'order/goods_refrigerator.png' : 'order/goods_washing_machine.png'
            }
            const img = await this.axios({
              url: process.env.BASE_API + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrlStr?objectName=${params.objectName}`,
              method: 'GET',
              headers: { // 设置请求头
                Authorization: this.$store.getters.token
              }
            }).then(res => {
              return res.data.data
            })
            element.goodsNorms = img
          })
          this.total = res.total
          this.arr = res.data
          this.list = this.arr.slice(0, this.search.pageSize)
        }
      })
    },
    getList(key) {
      //1 普通订单 0 网点订单
      if (this.type) {
        this.getDefaultList()
      } else {
        this.getBranchesList()
      }
    },
    importOrder() {
      this.dialogVisible = true
    },
    handleSelectionChange(rows) {
      // console.log(rows);
      // this.allSelectedIds 所有页选中的数据
      // this.currentTableData  当前页所有的数据
      // selectedIds  选中的项
      // unSelectedIds  未选中的项
      const selectedIds = rows.map((item) => item.id);
      const unSelectedIds = this.list
        .map((item) => item.id)
        .filter((item) => !selectedIds.includes(item));
      // // 获的所有选中的项
      this.allSelectedIds = this.allSelectedIds.filter(
        (item) => !unSelectedIds.includes(item)
      );
      // // //获得未选中的项
      this.unSelectedIds = unSelectedIds
      // // 数组去重
      this.allSelectedIds = [
        ...new Set([...this.allSelectedIds, ...selectedIds]),
      ];
      console.log(this.allSelectedIds, "this.allSelectedIds")
    },
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    delectUser(id) {
      this.$dialog({
        title: '温馨提示',
        content: '是否要删除，删除后不可以恢复！',
        cancel_buttton: '否',
        ok_buttton: '是',
        footBtn: false,
        width: '400px',
        footBtn: 'card',
        dialogType: 'delete',
        onOk: () => {
          let params = {
            ids: this.allSelectedIds.length ? this.allSelectedIds : [id],
            key: this.key
          }
          //1 普通订单 0 网点订单
          if (this.type) {
            this.HttpService.post(`/autoapp-default-server-recovery/api/tblRecycleOrder/delBatchOrderImportByIds`, params).then(res => {
              if (res.statusCode === 200)
                this.$message.success('删除成功')
              this.getList()
            })
          } else {
            this.HttpService.post(`/autoapp-default-server-recovery/api/recoveryOrder/delBatchWdOrderImportByIds`, params).then(res => {
              if (res.statusCode === 200)
                this.$message.success('删除成功')
              this.getList()
            })
          }
        },
        onCancel: () => {
          console.log('cancel');
        }
      })
    },
    download() {
      this.global.exportExcel('/autoapp-default-server-recovery/api/tblRecycleOrder/downloadOrderTemp', {}, '订单模版').catch((res) => {
        let blob = new Blob([res.response.data], {
          type: 'application/json',
        });
        var blobReader = new Response(blob).json();
        blobReader.then((res) => {
          this.$message.error(res.message);
        });
      });
      // setTimeout(() => {
      //   this.global.exportExcel('/autoapp-default-server-recovery/api/tblRecycleOrder/downloadWdOrderTemp', {}, '网点订单模版').catch((res) => {
      //     let blob = new Blob([res.response.data], {
      //       type: 'application/json',
      //     });
      //     var blobReader = new Response(blob).json();
      //     blobReader.then((res) => {
      //       this.$message.error(res.message);
      //     });
      //   });
      // }, 3000)

    },
    goCheck(id) {
      this.$router.push({
        path: "/order/orderCheck",
        query: {
          id: id,
          key: this.key,
          type: this.type,
        }
      });
    },
    //普通订单
    importUpdateDefaultByExcel(item) {
      this.defaultLoading = true;
      this.defaultUpLoadData = item
      this.Branches = false
    },
    //网点订单
    importUpdateBranchesByExcel(item) {
      this.branchesLoading = true;
      this.branchesUpLoadData = item
      this.Default = false
    },
    removueFile() {
      this.Branches = true
      this.Default = true
      this.defaultUpLoadData = {}
      this.branchesUpLoadData = {}
    },
    confirm() {
      if (this.key) {
        let params = {
          key: this.key
        }
        this.confimload = true
        let url = this.type ? `/autoapp-default-server-recovery/api/tblRecycleOrder/orderTrueImport/${params.key}` : `/autoapp-default-server-recovery/api/tblRecycleOrder/wdOrderTrueImport/${params.key}`
        this.HttpService.post(url, params).then(res => {
          if (res.statusCode === 200) {
            // this.$message.success('订单创建成功！')
            this.$dialog({
              title: '温馨提示',
              content: '创建成功!',
              footBtn: false,
              width: '20%',
              dialogType: 'success',
            })
            this.confimload = false
            this.getList()
          } else {
            this.confimload = false
          }

        })
      } else {
        this.$message.error('请重新创建订单')
      }
    },
    cancel() {
      if (this.key) {
        let params = {
          key: this.key
        }
        let url = `/autoapp-default-server-recovery/api/tblRecycleOrder/cancel/${params.key}`
        this.HttpService.post(url, params).then(res => {
          if (res.statusCode === 200) {
            this.list = []
          }
        })
      } else {
        this.$message.error('暂时没有订单')
      }
    },
    submitExcel() {
      if (this.global.handleEmptyData(this.defaultUpLoadData) && this.global.handleEmptyData(this.branchesUpLoadData)) {
        this.$message.error('请上传文件')
      } else {
        let formData = new FormData();
        if (!this.global.handleEmptyData(this.defaultUpLoadData)) {
          formData.append("file", this.defaultUpLoadData.file);
          this.HttpService.post('/autoapp-default-server-recovery/api/tblRecycleOrder/orderImport', formData).then(res => {
            if (res.statusCode != 200) {
              this.$message.error(res.message)
            } else {
              this.$message.success('导入成功')
              this.type = 1
              this.key = res.data
              this.getList()
            }
          })
        } else if (!this.global.handleEmptyData(this.branchesUpLoadData)) {
          formData.append("file", this.branchesUpLoadData.file);
          this.HttpService.post('/autoapp-default-server-recovery/api/tblRecycleOrder/wdOrderImport', formData).then(res => {
            if (res.statusCode != 200) {
              this.$message.error(res.message)
            } else {
              this.$message.success('导入成功')
              this.type = 0
              this.key = res.data
              this.getList()
            }
          })

        } else {

        }
        this.dialogVisible = false
      }
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.row-bg {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.orderEdit {
  width: 100%;
}
.goodsStyle {
  display: flex;
  align-items: center;
}
.tableBtn {
  cursor: pointer; // 悬浮时变手指
}
.btnclass {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/orderAdd.vue